import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "version---support-policy"
    }}>{`Version - Support policy`}</h1>
    <p>{`This document describes the PDF Services SDK's and Public API's
versioning and support policies.`}</p>
    <h2 {...{
      "id": "sdk"
    }}>{`SDK`}</h2>
    <h3 {...{
      "id": "versioning-scheme"
    }}>{`Versioning scheme`}</h3>
    <p>{`The SDK has a version format of `}{`#`}{`.`}{`#`}{`.`}{`#`}{` (e.g. 1.1.0) where the numbers
correspond to a major release, minor release, and patch/update
(Major.Minor.Patch). Releases are defined as follows:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Major Releases (1.x.x)`}</strong>{`: Major releases introduce
backward-incompatible changes to the APIs and interfaces and start
the EOL clock for all previous releases. Developers should plan on
migrating their code prior to the end of life of the previous major
release.`}</li>
      <li parentName="ul"><strong parentName="li">{`Minor Releases (x.1.x)`}</strong>{`: Minor releases typically appear
quarterly. Changes are backward compatible to the last major
release. Minor releases introduce new interfaces. Existing
interfaces continue to function but some interfaces may be
deprecated; deprecated interfaces will be removed in a next major
release.`}</li>
      <li parentName="ul"><strong parentName="li">{`Patch Releases (x.x.1)`}</strong>{`: Patch releases only deliver critical
security or bug fixes as needed. Patch release changes are rolled
into the next minor release so that developers can update and deploy
new code based on their business requirements.`}</li>
    </ul>
    <h2 {...{
      "id": "public-api"
    }}>{`Public API`}</h2>
    <h3 {...{
      "id": "versioning"
    }}>{`Versioning`}</h3>
    <p>{`As mentioned on `}<a parentName="p" {...{
        "href": "../../apis"
      }}>{`Public API
Docs`}</a>{`,
each operation has a unique assetId which is passed in Form Parameters.
Generally, APIs will be enhanced while keeping them backward compatible.
If its functionality can't be enhanced without breaking changes, then
its new version will be released with its own unique assetId. The
supported older API versions info will be present on `}<a parentName="p" {...{
        "href": "https://documentcloud.adobe.com/document-services/index.html"
      }}>{`Public API
Docs`}</a></p>
    <p>{`Additionally, the output for the PDF Extract API is generated by a
machine learning pipeline that is frequently trained to improve
inference of document layout and structure.As a result, while changes to
the output structure are not expected between versions, specific results
may vary as the model output improves.`}</p>
    <h2 {...{
      "id": "supported-versions"
    }}>{`Supported versions`}</h2>
    <p>{`This document as well as the URLs on Adobe's website and other
documentation link to the latest product version.`}</p>
    <p><strong parentName="p">{`Note`}</strong>{`: Links to repository assets (e.g. GIT, Maven, etc.) direct to
the top level directory. To download assets that match the
documentation, navigate to the correct version. For example, When using
the 1.0.0 Java documentation, you can find the 1.0.0 samples in the GIT
repo as follows:`}</p>
    <ol>
      <li parentName="ol">{`Go to the `}<a parentName="li" {...{
          "href": "https://www.adobe.com/go/pdftoolsapi_java_samples"
        }}>{`GIT repo`}</a>{`.`}</li>
      <li parentName="ol">{`Select `}<em parentName="li">{`Releases`}</em>{`.`}</li>
      <li parentName="ol">{`Select and download the needed release.`}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "927px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "34.06249999999999%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/67f1ec4d2505ab0e8bcf7287d450673f/5530d/prevrelease.webp 320w", "/document-services/docs/static/67f1ec4d2505ab0e8bcf7287d450673f/0c8fb/prevrelease.webp 640w", "/document-services/docs/static/67f1ec4d2505ab0e8bcf7287d450673f/2c8f1/prevrelease.webp 927w"],
            "sizes": "(max-width: 927px) 100vw, 927px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/67f1ec4d2505ab0e8bcf7287d450673f/dd4a7/prevrelease.png 320w", "/document-services/docs/static/67f1ec4d2505ab0e8bcf7287d450673f/0f09e/prevrelease.png 640w", "/document-services/docs/static/67f1ec4d2505ab0e8bcf7287d450673f/0342e/prevrelease.png 927w"],
            "sizes": "(max-width: 927px) 100vw, 927px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/67f1ec4d2505ab0e8bcf7287d450673f/0342e/prevrelease.png",
            "alt": "Previous Release tags with release notes and links to the assets",
            "title": "Previous Release tags with release notes and links to the assets",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "migration-guide-to-pdf-services-sdk"
    }}>{`Migration Guide to PDF Services SDK`}</h2>
    <p>{`Refer to the following table for migrating to PDF Services SDK version
3.4.0, you can also refer our Samples(
`}<a parentName="p" {...{
        "href": "https://www.adobe.com/go/pdftoolsapi_java_samples"
      }}>{`Java`}</a>{`, `}<a parentName="p" {...{
        "href": "https://www.adobe.com/go/pdftoolsapi_node_sample"
      }}>{`Node
JS`}</a>{`,
`}<a parentName="p" {...{
        "href": "https://www.adobe.com/go/pdftoolsapi_net_samples"
      }}>{`.NET`}</a>{`). for the
latest release.`}</p>
    <InlineAlert slots="text" mdxType="InlineAlert" />
    <p>{`The 1.X.X versions of PDF Tools SDK will be reaching End of Life in
May 2022. Once a version reaches its end of life, functionality may be
deprecated and stop working. Please upgrade to use our latest SDK
version.`}</p>
    <h3 {...{
      "id": "java-changes"
    }}>{`Java changes`}</h3>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`artifactId`}</inlineCode>{` changed from `}<inlineCode parentName="li">{`pdftools-sdk`}</inlineCode>{` to `}<inlineCode parentName="li">{`pdfservices-sdk`}</inlineCode></li>
      <li parentName="ul">{`Replace the `}<inlineCode parentName="li">{`<properties>`}</inlineCode>{` tag and SDK `}<inlineCode parentName="li">{`<dependency>`}</inlineCode>{` tag in your project's `}<inlineCode parentName="li">{`pom.xml`}</inlineCode>{` file with the following:`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`<properties>
    <project.build.sourceEncoding>UTF-8</project.build.sourceEncoding>
    <maven.compiler.source>11</maven.compiler.source>
    <maven.compiler.target>11</maven.compiler.target>
    <pdfservices.sdk.version>4.3.0</pdfservices.sdk.version>
    <pdfservices.sdk.samples.version>4.3.0</pdfservices.sdk.samples.version>
</properties>

<dependency>
    <groupId>com.adobe.documentservices</groupId>
    <artifactId>pdfservices-sdk</artifactId>
    <version>\${pdfservices.sdk.version}</version>
</dependency>
`}</code></pre>
    <ul>
      <li parentName="ul">{`Update import statements as per new Package structure. For e.g.`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`import com.adobe.pdfservices.operation.ExecutionContext; 
`}</code></pre>
    <h3 {...{
      "id": "node-js-changes"
    }}>{`Node JS changes`}</h3>
    <ul>
      <li parentName="ul">{`NPM package name changed from `}<inlineCode parentName="li">{`@adobe/documentservices-pdftools-node-sdk`}</inlineCode>{` to `}<inlineCode parentName="li">{`@adobe/pdfservices-node-sdk`}</inlineCode></li>
      <li parentName="ul">{`Update the latest SDK dependency in package.json file of your project`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`"@adobe/pdfservices-node-sdk": "4.1.0"
`}</code></pre>
    <ul>
      <li parentName="ul">{`Require the `}<inlineCode parentName="li">{`@adobe/pdfservices-node-sdk`}</inlineCode>{` in the Sample file to access the SDK interface`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const PDFServicesSdk = require('@adobe/pdfservices-node-sdk'); 
`}</code></pre>
    <p>{`For HTML to PDF Conversions, the PageLayout object is moved inside html object. To access the PageLayout interface use the following code:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const pageLayout = new PDFServicesSdk.CreatePDF.options.html.PageLayout(); 
`}</code></pre>
    <h3 {...{
      "id": "net-changes"
    }}>{`.NET changes`}</h3>
    <ul>
      <li parentName="ul">{`Nuget package name changed from `}<inlineCode parentName="li">{`Adobe.DocumentServices.PDFTools`}</inlineCode>{` to `}<inlineCode parentName="li">{`Adobe.PDFServicesSDK`}</inlineCode></li>
      <li parentName="ul">{`Update the SDK dependency in your project's .csproj file with the following:`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`<ItemGroup>
    <PackageReference Include="log4net" Version="2.0.17" />
    <PackageReference Include="Adobe.PDFServicesSDK" Version="4.2.0" />
</ItemGroup> 
`}</code></pre>
    <ul>
      <li parentName="ul">{`Update the namespaces accordingly in your .cs file as per the new dependency:`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`using Adobe.PDFServicesSDK;
`}</code></pre>
    <h3 {...{
      "id": "python-changes"
    }}>{`Python changes`}</h3>
    <ul>
      <li parentName="ul">{`Add the following dependency in your project's requirements.txt file:`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`pdfservices-sdk~=4.1.0
`}</code></pre>
    <h2 {...{
      "id": "archived-documentation"
    }}>{`Archived Documentation`}</h2>
    <p>{`The last major version of our documentation may be found `}<a parentName="p" {...{
        "href": "../legacy-documentation/"
      }}>{`here`}</a>{`.`}</p>
    <h2 {...{
      "id": "change-types"
    }}>{`Change types`}</h2>
    <p>{`Change types include the following:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`New`}</strong>{`: Features or implementation changes added in the current
release.`}</li>
      <li parentName="ul"><strong parentName="li">{`Changed`}</strong>{`: Modified code that changes a feature or implementation
detail.`}</li>
      <li parentName="ul"><strong parentName="li">{`Security`}</strong>{`: A patch or bug fixed released in an out-of-band patch.`}</li>
      <li parentName="ul"><strong parentName="li">{`Deprecated`}</strong>{`: Existing functionality for which support is ending
(or ended).`}</li>
    </ul>
    <InlineAlert slots="text" mdxType="InlineAlert" />
    <p>{`Minor and Patch releases are backward compatible with the previous release.
Upgrading to the latest SDK should not break existing applications.`}</p>
    <h2 {...{
      "id": "change-history"
    }}>{`Change history`}</h2>
    <h3 {...{
      "id": "may-22-2025-net-sdk-430-release"
    }}>{`May 22, 2025; .NET SDK 4.3.0 Release`}</h3>
    <ul>
      <li parentName="ul">{`Added support for `}<a parentName="li" {...{
          "href": "../pdf-services-api/howtos/export-pdf-form-data/"
        }}>{`Export PDF Form Data`}</a>{` and `}<a parentName="li" {...{
          "href": "../pdf-services-api/howtos/import-pdf-form-data/"
        }}>{`Import PDF Form Data`}</a>{` operations in PDF Services .NET SDK, enabling users to extract and populate form Data.`}</li>
    </ul>
    <h3 {...{
      "id": "may-12-2025-python-sdk-411-release"
    }}>{`May 12, 2025; Python SDK 4.1.1 Release`}</h3>
    <ul>
      <li parentName="ul">{`Streamlined runtime dependencies (setuptools) for installation efficiency.`}</li>
      <li parentName="ul">{`Enhanced XML processing security with a secure XML parser`}</li>
    </ul>
    <h3 {...{
      "id": "april-30-2025-adobe-document-generation-server-side-release"
    }}>{`April 30, 2025; Adobe Document Generation Server Side Release`}</h3>
    <ul>
      <li parentName="ul">{`Added support for text indentation styles in Document Generation API`}</li>
      <li parentName="ul">{`Added support for text alignment styles in Document Generation API`}</li>
      <li parentName="ul">{`Bug fix for content duplication occurring with content involving paragraphs, lists and tables.`}</li>
    </ul>
    <h3 {...{
      "id": "april-25-2025-adobe-document-generation-server-side-release"
    }}>{`April 25, 2025; Adobe Document Generation Server Side Release`}</h3>
    <ul>
      <li parentName="ul">{`Bug fixes for font inconsistencies occurring with content around tables.`}</li>
      <li parentName="ul">{`Added support for Superscript and Subscript in Document Generation API.`}</li>
      <li parentName="ul">{`Enhanced Document Generation API to recognize and render heading tags.`}</li>
      <li parentName="ul">{`Temporary fix to address the file corruption issue.`}</li>
    </ul>
    <h3 {...{
      "id": "april-22-2025-java-sdk-430-release"
    }}>{`April 22, 2025; Java SDK 4.3.0 Release`}</h3>
    <ul>
      <li parentName="ul">{`Added support for `}<a parentName="li" {...{
          "href": "../pdf-services-api/howtos/export-pdf-form-data/"
        }}>{`Export PDF Form Data`}</a>{` and `}<a parentName="li" {...{
          "href": "../pdf-services-api/howtos/import-pdf-form-data/"
        }}>{`Import PDF Form Data`}</a>{` operations in PDF Services Java SDKs, enabling users to extract and populate form Data.`}</li>
      <li parentName="ul">{`Added support for active sheet conversion in the Excel to PDF operation, allowing users to convert only the active sheet instead of the entire workbook.`}</li>
      <li parentName="ul">{`Added support for pageRange in the Create PDF operation for all supported file formats, enabling selective page conversion.`}</li>
      <li parentName="ul">{`Introduced `}<inlineCode parentName="li">{`waitTimeToLoad`}</inlineCode>{` support in the HTML to PDF operation, allowing users to specify the maximum wait time (in milliseconds) before finalizing the PDF.`}</li>
    </ul>
    <h3 {...{
      "id": "march-03-2025-adobe-document-generation-server-side-release"
    }}>{`March 03, 2025; Adobe Document Generation Server Side Release`}</h3>
    <ul>
      <li parentName="ul">{`Bug fixes in conditional-sections usage.`}</li>
    </ul>
    <h3 {...{
      "id": "february-24-2025-adobe-document-generation-server-side-release"
    }}>{`February 24, 2025; Adobe Document Generation Server Side Release`}</h3>
    <ul>
      <li parentName="ul">{`Added support for charts in Document Generation API, allowing users to insert different charts dynamically.`}</li>
    </ul>
    <h3 {...{
      "id": "february-21-2025-net-sdk-420-release"
    }}>{`February 21, 2025; .NET SDK 4.2.0 release`}</h3>
    <ul>
      <li parentName="ul">{`Added support for active sheet conversion in the Excel to PDF operation, allowing users to convert only the active sheet instead of the entire workbook.`}</li>
      <li parentName="ul">{`Added support for pageRange in the Create PDF operation for all supported file formats, enabling selective page conversion.`}</li>
      <li parentName="ul">{`Introduced `}<inlineCode parentName="li">{`waitTimeToLoad`}</inlineCode>{` support in the HTML to PDF operation, allowing users to specify the maximum time (in milliseconds) to wait before finalizing the PDF`}</li>
    </ul>
    <h3 {...{
      "id": "february-17-2025-adobe-document-generation-server-side-release"
    }}>{`February 17, 2025; Adobe Document Generation Server Side Release`}</h3>
    <ul>
      <li parentName="ul">{`Added support for footnotes phrases in Document Generation API.`}</li>
    </ul>
    <h3 {...{
      "id": "february-4-2025-server-side-release"
    }}>{`February 4, 2025; Server Side Release`}</h3>
    <ul>
      <li parentName="ul">{`Added `}<a parentName="li" {...{
          "href": "../pdf-services-api/howtos/export-pdf-form-data/"
        }}>{`Export PDF Form Data API`}</a>{` operation in PDF Services API to retrieve the data from a PDF form and return it as a JSON file.`}</li>
      <li parentName="ul">{`Added `}<a parentName="li" {...{
          "href": "../pdf-services-api/howtos/import-pdf-form-data/"
        }}>{`Import PDF Form Data API`}</a>{` operation in PDF Services API to populate PDF forms with JSON data and generate the resulting PDF document.`}</li>
    </ul>
    <h3 {...{
      "id": "november-06-2024-adobe-document-generation-server-side-release"
    }}>{`November 06, 2024; Adobe Document Generation Server Side Release`}</h3>
    <ul>
      <li parentName="ul">{`Restricting tag length to 1000 characters in the Document Generation API.`}</li>
    </ul>
    <h3 {...{
      "id": "november-06-2024-java-sdk-420-and-nodejs-net-python-sdk-410-minor-release"
    }}>{`November 06, 2024; Java SDK 4.2.0 and NodeJS, .NET, Python SDK 4.1.0 minor release`}</h3>
    <ul>
      <li parentName="ul">{`PDF Watermark and PDF Accessibility Checker operations are now available for all the users in PDF Services SDKs.`}</li>
    </ul>
    <h3 {...{
      "id": "october-1-2024-java-sdk-411-patch-release"
    }}>{`October 1, 2024; Java SDK 4.1.1 patch release`}</h3>
    <ul>
      <li parentName="ul">{`Bug fixes and stability improvements.`}</li>
    </ul>
    <h3 {...{
      "id": "september-10-2024-adobe-document-generation-server-side-release"
    }}>{`September 10, 2024; Adobe Document Generation Server Side Release`}</h3>
    <ul>
      <li parentName="ul">{`Enhanced support for `}<a parentName="li" {...{
          "href": "../document-generation-api/templatetags/#jsonata-functions"
        }}>{`JSONata functions`}</a>{` in Table Tag with Markers.`}</li>
    </ul>
    <h3 {...{
      "id": "august-23-2024-added-new-features-for-document-generation-api-and-updated-acrobat-service-api-postman-collection"
    }}>{`August 23, 2024; Added new features for Document Generation API and updated Acrobat Service API postman collection`}</h3>
    <ul>
      <li parentName="ul">{`Added base64 format support for inline images.`}</li>
      <li parentName="ul">{`Supported attributes for img tag (height and width only).`}</li>
      <li parentName="ul">{`Postman collection for external storage : Electronic Seal, Extract, Split, Accessibility Checker.`}</li>
      <li parentName="ul">{`Added request body schema with example for accessibility checker with external storage.`}</li>
    </ul>
    <h3 {...{
      "id": "july-30-2024-pdf-accessibility-checker-api-added"
    }}>{`July 30, 2024; PDF Accessibility Checker API Added`}</h3>
    <ul>
      <li parentName="ul">{`Added `}<a parentName="li" {...{
          "href": "../pdf-services-api/howtos/pdf-accessibility-checker-api/"
        }}>{`PDF Accessibility Checker`}</a>{` operation in PDF Services API to check accessibility on specified pages of PDF document.`}</li>
    </ul>
    <h3 {...{
      "id": "july-22-2024-net-sdk-400-major-release"
    }}>{`July 22, 2024; .NET SDK 4.0.0 major release`}</h3>
    <ul>
      <li parentName="ul">{`Released Adobe PDF Services .NET SDK v4.0.0, introducing new interfaces fully leveraging power of new PDF Services rest APIs.`}</li>
      <li parentName="ul">{`Added support for delete asset, refresh download URI and webhook notifiers.`}</li>
      <li parentName="ul">{`Eliminated need of storage to save intermediate result by removing dependency on temporary storage.`}</li>
      <li parentName="ul">{`Extended I/O capabilities by introducing external storage for PDF Services operations.`}</li>
      <li parentName="ul">{`Enabled connection to Internet through Proxy, where proxy server settings can be set via "proxyServerConfig" in the client config.`}</li>
      <li parentName="ul">{`Updated PDF Properties operation to return PDFProperties object along with JSON string.`}</li>
      <li parentName="ul">{`Updated Extract PDF operation to return content and resource asset along with content JSON object.`}</li>
    </ul>
    <h3 {...{
      "id": "july-16-2024-server-side-release---get-pdf-properties"
    }}>{`July 16, 2024; Server Side Release - Get PDF Properties`}</h3>
    <ul>
      <li parentName="ul">{`Bug fixes `}<a parentName="li" {...{
          "href": "../pdf-services-api/howtos/pdf-properties/"
        }}>{`Get PDF Properties`}</a>{` fixed data issue related to permissions in JSON response.`}</li>
    </ul>
    <h3 {...{
      "id": "july-09-2024-server-side-release"
    }}>{`July 09, 2024; Server Side Release`}</h3>
    <ul>
      <li parentName="ul">{`Added `}<a parentName="li" {...{
          "href": "../pdf-services-api/howtos/pdf-watermark-api/"
        }}>{`PDF Watermark`}</a>{` operation in PDF Services API to add a watermark on specified pages of PDF document.`}</li>
    </ul>
    <h3 {...{
      "id": "june-12-2024-nodejs-sdk-401-patch-release"
    }}>{`June 12, 2024; NodeJS SDK 4.0.1 patch release`}</h3>
    <ul>
      <li parentName="ul">{`Bug fixes and stability improvements.`}</li>
    </ul>
    <h3 {...{
      "id": "june-05-2024-net-sdk-351-patch-release"
    }}>{`June 05, 2024; .NET SDK 3.5.1 patch release`}</h3>
    <ul>
      <li parentName="ul">{`Bug fixes and stability improvements.`}</li>
    </ul>
    <h3 {...{
      "id": "june-04-2024-java-sdk-410-minor-release"
    }}>{`June 04, 2024; Java SDK 4.1.0 minor release`}</h3>
    <ul>
      <li parentName="ul">{`Extend support for external storage and notifier config for all the operations.`}</li>
    </ul>
    <h3 {...{
      "id": "may-22-2024-python-sdk-400-major-release"
    }}>{`May 22, 2024; Python SDK 4.0.0 major release`}</h3>
    <ul>
      <li parentName="ul">{`Released Adobe PDF Services Python SDK v4.0.0, introducing new interfaces fully leveraging power of new PDF Services REST APIs.`}</li>
      <li parentName="ul">{`Added support for all the operations powered by the Adobe PDF Services APIs.`}</li>
      <li parentName="ul">{`Added support for deleting assets and webhook notifiers.`}</li>
      <li parentName="ul">{`Removed the need for intermediate result storage for chained operations by eliminating reliance on temporary local storage.`}</li>
      <li parentName="ul">{`Extended I/O capabilities by introducing external storage for PDF Services operations.`}</li>
      <li parentName="ul">{`Enabled connection to Internet through Proxy, where proxy server settings can be set via Proxy Server Config.`}</li>
    </ul>
    <h3 {...{
      "id": "may-15-2024-net-sdk-350-minor-release"
    }}>{`May 15, 2024; .NET SDK 3.5.0 minor release`}</h3>
    <ul>
      <li parentName="ul">{`Added support to enable or disable "configureAwait" using client config, which will allow developers to specify whether asynchronous continuations should execute on the original synchronization context or not. `}<strong parentName="li">{`Note`}</strong>{`: Starting from the next major release, "configureAwait" will be disabled by default and won't be configurable.`}</li>
    </ul>
    <h3 {...{
      "id": "april-30-2024-adobe-document-generation-server-side-release"
    }}>{`April 30, 2024; Adobe Document Generation Server Side Release`}</h3>
    <ul>
      <li parentName="ul">{`Added support for `}<a parentName="li" {...{
          "href": "../document-generation-api/tablewithmarkers/#discard-the-row-in-a-horizontal-table-if-the-condition-evaluates-to-true"
        }}>{`discard the row in a horizontal table`}</a>{` in Document Generation API.`}</li>
    </ul>
    <h3 {...{
      "id": "april-2024-nodejs-sdk-400-major-release"
    }}>{`April, 2024; NodeJS SDK 4.0.0 major release`}</h3>
    <ul>
      <li parentName="ul">{`Released Adobe PDF Services Node SDK v4.0.0, introducing new interfaces fully leveraging power of new PDF Services rest APIs.`}</li>
      <li parentName="ul">{`Added support for delete asset and webhook notifiers.`}</li>
      <li parentName="ul">{`Eliminated need of storage to save intermediate result by removing dependency on temporary storage.`}</li>
      <li parentName="ul">{`Extended I/O capabilities by introducing external storage for PDF Services operations.`}</li>
      <li parentName="ul">{`Enabled connection to Internet through Proxy, where proxy server settings can be set via "proxyServerConfig" in the client config.`}</li>
      <li parentName="ul">{`Updated PDF Properties operation to return PDFProperties object along with JSON string.`}</li>
      <li parentName="ul">{`Updated Extract PDF operation to return content and resource asset along with content JSON object.`}</li>
    </ul>
    <h3 {...{
      "id": "april-2024-server-side-release"
    }}>{`April, 2024; Server Side Release`}</h3>
    <ul>
      <li parentName="ul">{`Added support for `}<a parentName="li" {...{
          "href": "../pdf-services-api/howtos/webhook-notification/"
        }}>{`Webhook Notification`}</a>{` in PDF Properties.`}</li>
      <li parentName="ul">{`Added support for `}<a parentName="li" {...{
          "href": "../pdf-services-api/howtos/pdf-external-storage-sol/"
        }}>{`External Storage`}</a>{` in Extract PDF, Split PDF, PDF Electronic Seal and Auto-Tag PDF.`}</li>
      <li parentName="ul">{`Added support for `}<a parentName="li" {...{
          "href": "../pdf-services-api/howtos/webhook-notification/"
        }}>{`Webhook Notification`}</a>{` for external storage operations.`}</li>
    </ul>
    <h3 {...{
      "id": "march-2024-python-sdk-231-patch-release"
    }}>{`March, 2024; Python SDK 2.3.1 patch release`}</h3>
    <ul>
      <li parentName="ul">{`PDF operations now support configurable timeouts.`}</li>
    </ul>
    <h3 {...{
      "id": "february-2024-net-sdk-341-patch-release"
    }}>{`February, 2024: .NET SDK 3.4.1 patch release`}</h3>
    <ul>
      <li parentName="ul">{`Dependent library upgrades and fixed compatibility issues with RestSharp v110+.`}</li>
    </ul>
    <h3 {...{
      "id": "january-2024-java-sdk-400-major-release"
    }}>{`January, 2024; Java SDK 4.0.0 major release`}</h3>
    <ul>
      <li parentName="ul">{`Released Adobe PDF Services Java SDK v4.0.0, introducing new interfaces fully leveraging power of new PDF Services rest APIs.`}</li>
      <li parentName="ul">{`Added support for delete asset, refresh download URI, webhook notifiers.`}</li>
      <li parentName="ul">{`Eliminated need of storage to save intermediate result by removing dependency on temporary storage.`}</li>
      <li parentName="ul">{`Extended I/O capabilities by introducing external storage for a majority of PDF Services operations.`}</li>
      <li parentName="ul">{`Updated PDF Properties operation to return PDFProperties object along with JSON string.`}</li>
      <li parentName="ul">{`Updated Extract PDF operation to return content and resource asset along with content JSON object.`}</li>
    </ul>
    <h3 {...{
      "id": "january-2024-server-side-release"
    }}>{`January, 2024; Server Side Release`}</h3>
    <ul>
      <li parentName="ul">{`Added support for `}<a parentName="li" {...{
          "href": "../pdf-services-api/howtos/webhook-notification/"
        }}>{`Webhook Notification`}</a>{` in all the operations `}<strong parentName="li">{`except`}</strong>{` PDF Properties.`}</li>
    </ul>
    <h3 {...{
      "id": "january-2024-adobe-document-generation-server-side-release"
    }}>{`January, 2024: Adobe Document Generation Server Side Release`}</h3>
    <ul>
      <li parentName="ul">{`Added support for `}<a parentName="li" {...{
          "href": "../document-generation-api/tablewithmarkers"
        }}>{`Table Tag with Markers`}</a>{` in Document Generation API.`}</li>
    </ul>
    <h3 {...{
      "id": "december-2023-java-sdk-351-patch-release"
    }}>{`December, 2023: Java SDK 3.5.1 patch release`}</h3>
    <ul>
      <li parentName="ul">{`Dependent library upgrades and fixed compatibility issues with Spring Boot v3.x.`}</li>
    </ul>
    <h3 {...{
      "id": "october-2023-java-sdk-350-minor-release"
    }}>{`October, 2023: Java SDK 3.5.0 minor release`}</h3>
    <ul>
      <li parentName="ul">{`Added support for document level permissions and trusted timestamping (using `}<a parentName="li" {...{
          "href": "../pdf-electronic-seal-api/#supported-timestamping-authorities"
        }}>{`supported TSAs`}</a>{`) in java sdk for `}<a parentName="li" {...{
          "href": "../pdf-electronic-seal-api/"
        }}>{`PDF Electronic Seal API`}</a>{`.`}</li>
    </ul>
    <h3 {...{
      "id": "october-2023-adobe-document-generation-server-side-release"
    }}>{`October, 2023; Adobe Document Generation Server Side Release`}</h3>
    <ul>
      <li parentName="ul">{`Performance Improvements - Available in `}<a parentName="li" {...{
          "href": "../apis/#tag/Document-Generation"
        }}>{`REST API`}</a>{` and SDK(s) v3.0.0 and above.`}</li>
    </ul>
    <h3 {...{
      "id": "august-2023-server-side-release"
    }}>{`August, 2023; Server Side Release`}</h3>
    <ul>
      <li parentName="ul">{`Added support for document level permissions and trusted timestamping (using `}<a parentName="li" {...{
          "href": "../pdf-electronic-seal-api/#supported-timestamping-authorities"
        }}>{`supported TSAs`}</a>{`) in `}<a parentName="li" {...{
          "href": "../pdf-electronic-seal-api/"
        }}>{`PDF Electronic Seal API`}</a>{`.`}</li>
      <li parentName="ul">{`Added support for `}<a parentName="li" {...{
          "href": "../pdf-services-api/howtos/pdf-external-storage-sol/"
        }}>{`External Storage`}</a>{` in all the operations `}<strong parentName="li">{`except`}</strong>{` Extract PDF, Split PDF, PDF Electronic Seal and Auto-Tag PDF.`}</li>
    </ul>
    <h3 {...{
      "id": "august-2023-nodejs-sdk-342-minor-release"
    }}>{`August, 2023, NodeJS SDK 3.4.2 minor release`}</h3>
    <ul>
      <li parentName="ul">{`Restructured the internals for improved organization.`}</li>
    </ul>
    <h3 {...{
      "id": "july-2023-nodejs-sdk-341-minor-release"
    }}>{`July, 2023, NodeJS SDK 3.4.1 minor release`}</h3>
    <ul>
      <li parentName="ul">{`Fixed links in README.md file.`}</li>
    </ul>
    <h3 {...{
      "id": "june-2023-javanodejsnet-sdk-340-minor-release"
    }}>{`June, 2023; Java,NodeJS,.NET SDK 3.4.0 minor release`}</h3>
    <ul>
      <li parentName="ul">{`PDF Electronic Seal operation is now available for all the users in PDF Services SDKs and REST APIs.`}</li>
      <li parentName="ul">{`Added support for OAuth based Server to Server credentials in PDF Services SDKs.`}</li>
      <li parentName="ul">{`JWT based service account credentials and corresponding SDK interfaces are now deprecated.`}</li>
    </ul>
    <h3 {...{
      "id": "june-2023-python-sdk-230-minor-release"
    }}>{`June, 2023; Python SDK 2.3.0 minor release`}</h3>
    <ul>
      <li parentName="ul">{`Added support for OAuth based Server to Server credentials in PDF Services SDKs.`}</li>
      <li parentName="ul">{`JWT based service account credentials and corresponding SDK interfaces are now deprecated.`}</li>
    </ul>
    <h3 {...{
      "id": "june-2023-adobe-document-generation-server-side-release"
    }}>{`June, 2023; Adobe Document Generation Server Side Release`}</h3>
    <ul>
      <li parentName="ul">{`Added support for `}<a parentName="li" {...{
          "href": "../pdf-services-api/howtos/pdf-external-storage-sol/"
        }}>{`External Storage`}</a>{` in Document Generation API.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      